// @ts-nocheck

import React from 'react';
import { Switch } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import styled, { keyframes } from 'styled-components';

import useRouter from '../../hooks/useRouter';

const scaleUp = keyframes`
  0% {
    transform:scale(.9);
    opacity: 0;
  }
  100% {
    transform:scale(1);
    opacity: 1;
  }
`;

const scaleDown = keyframes`
  0% {
    transform:scale(1);
    opacity: 1;
  }
  100% {
    transform:scale(.9);
    opacity: 0;
  }
`;

const StyledTransitionGroup = styled(TransitionGroup)`
  .scale-route-enter {
    animation: ${scaleUp} 250ms ease-out forwards;
  }
  .scale-route-exit {
    animation: ${scaleDown} 200ms ease-in forwards;
  }
`;

const ScaleRouteTransitionGroup = ({ children }) => {
  const { location } = useRouter();

  return (
    <StyledTransitionGroup>
      <CSSTransition key={location.key} timeout={{ enter: 250, exit: 200 }} classNames="scale-route">
        <Switch location={location}>{children}</Switch>
      </CSSTransition>
    </StyledTransitionGroup>
  );
};

export default ScaleRouteTransitionGroup;
